import { useTranslation } from "@opendash/i18n";
import { Alert } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  name: string;
  error?: string; // should be a translation key
};

export const MetaFieldNameInput = observer((props: Props) => {
  const t = useTranslation();
  const [name, setName] = useState(props.name || "");

  useEffect(() => {
    if (props.name !== name) {
      setName(props.name);
      props.onChange?.(props.name);
    }
  }, [props.name, name]);

  return (
    <Alert
      message={t("maintenance:ticket_creation.fields.meta.fields.name", {
        name,
      })}
      type={props.error ? "error" : "info"}
      description={props.error ? t(props.error) : undefined}
      showIcon
    />
  );
});
